import {
  GetAllRetailers_allRetailers_edges_node_safetyEnvironment,
} from '@src/app/generated/GetAllRetailers';
import { SafetyEnvironmentInput } from '@src/app/generated/globalTypes';
import { Id, SafetyEnvironment } from '@ess/jg-rule-executor';
import { Retailer } from '@src/app/model/retailer';
import { PortalInvariant } from '@src/app/model/portal-invariant';
import { PortalModuleBlueprint } from '@src/app/model/portal-module-blueprint';

/**
 * Safety environment
 */
export class PortalSafetyEnvironment extends SafetyEnvironment {
  declare invariants: PortalInvariant[];

  static fromGql(
    retailerId: Id<Retailer>,
    gql: GetAllRetailers_allRetailers_edges_node_safetyEnvironment
  ): PortalSafetyEnvironment {
    return new PortalSafetyEnvironment(
      retailerId,
      gql.invariants.map(i => new PortalInvariant(
        i.id,
        i.rule,
        PortalInvariant.keysFromGql(i.translationKeys),
        PortalInvariant.translationsFromGql(i.translations),
        i.correction,
        i.name,
        i.disableDuringOnChange
      )),
      gql.invariantTemplates
    );
  }

  toGqlInput(): SafetyEnvironmentInput {
    return {
      invariants: this.invariants.map(i => PortalModuleBlueprint.invariantToGqlInput(i)),
      invariantTemplates: this.invariantTemplates,
    };
  }
}
